<script setup lang="ts">
import { toRef } from 'vue';
import { initials } from '@/lib/format';
import { useFileUrl } from '@/composables/useFileUrl';

const props = withDefaults(defineProps<{ name: string; fileId?: string | null; size?: 'sm' | 'md' | 'lg' }>(), { size: 'md' });
const url = useFileUrl(toRef(props, 'fileId'));
const sizes = { sm: 'h-7 w-7 text-[10px]', md: 'h-9 w-9 text-xs', lg: 'h-16 w-16 text-lg' };
</script>

<template>
  <img v-if="url" :src="url" :alt="name" class="shrink-0 rounded-full object-cover" :class="sizes[size]" />
  <span v-else class="inline-flex shrink-0 items-center justify-center rounded-full bg-navy-100 font-semibold text-navy-700 dark:bg-navy-800 dark:text-navy-100" :class="sizes[size]" aria-hidden="true">
    {{ initials(name) }}
  </span>
</template>
